import * as React from 'react'

function SvgUsefulLinks(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.744 5.005a1.502 1.502 0 000 2.123 1.498 1.498 0 002.12 0l.88-.88a4.25 4.25 0 016.013 0 4.26 4.26 0 010 6.02l-4.745 4.749L12 10.037a1.635 1.635 0 00-2.31.003l-5.566 5.572a7.262 7.262 0 000 10.263 7.247 7.247 0 0010.255 0l.797-.798a1.502 1.502 0 000-2.122 1.498 1.498 0 00-2.12 0l-.798.798a4.25 4.25 0 01-6.014 0 4.259 4.259 0 010-6.02l4.606-4.609 6.89 6.86a1.5 1.5 0 002.313.236l5.825-5.83a7.262 7.262 0 000-10.264 7.247 7.247 0 00-10.255 0l-.879.88z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgUsefulLinks
